module.exports = __webpack_public_path__ + "img/covid_web.16486f71.png";